import { BASE_URL } from '../config';
import { STATE } from '../classes/Enum';
import { apiFetch } from '../helper/apiClient';

function appendFilterValues(params, key, values) {
    const list = Array.isArray(values) ? values : (values ? [values] : []);
    for (const value of list) {
        const trimmed = String(value || "").trim();
        if (trimmed) {
            params.append(key, trimmed);
        }
    }
}

export async function getInventory(state, page, q = "", filters = {}) {
    try {
        const params = new URLSearchParams();

        if (state && state !== STATE.OVERVIEW) {
            params.set("page_type", String(state));
        }
        
        if (page != null) {
            params.set("page", String(page));
        }

        if (q && q.trim()) {
            params.set("q", q.trim());
        }

        if (filters.sort) {
            params.set("sort", filters.sort);
        }
        appendFilterValues(params, "series", filters.series);
        appendFilterValues(params, "set", filters.set);
    
        const response = await apiFetch(`products/get?${params.toString()}`, {
            method: 'GET',
        }, { auth: true });

        const responseBody = await response.json();

        if (response.ok) {
            return {
                items: responseBody.items || [],
                filterOptions: responseBody.filter_options || null,
                searchEventId: responseBody.search_event_id ?? null,
            };
        } else {
            throw new Error(responseBody.detail || 'Failed to retrieve Products');
        }

    } catch (error) {
        console.error('Request to retrieve Products failed:', error.message);
        throw error;
    }
}

export async function getSet(setId) {
    try {
        const response = await apiFetch(`cards?sets=${encodeURIComponent(setId)}`, {
            method: 'GET',
        });

        const responseBody = await response.json();
        if (response.ok) {
            return responseBody;
        } else {
            throw new Error(responseBody.detail || 'Failed to retrieve set');
        }
    } catch (error) {
        throw new Error('Failed to retrieve set: ' + error.message);
        
    }
}

export async function getProduct(id) {
    try {
        const response = await apiFetch(`products/get/${encodeURIComponent(id)}`, {
            method: 'GET',
        });

        const responseBody = await response.json();
        if (response.ok) {
            return responseBody;
        } else {
            throw new Error(responseBody.detail || 'Failed to retrieve product with id:' + id);
        }
    } catch (error) {
        throw new Error('Failed to retrieve set: ' + error.message);
        
    }
}

function normalizeProductIds(ids) {
  const values = Array.isArray(ids) ? ids : [ids];
  const parsed = [];

  for (const value of values) {
    if (value == null) continue;

    if (typeof value === "object") {
      const id = value.id ?? value.productId ?? value.cardId ?? value.card_id;
      if (id != null) {
        const n = Number(id);
        if (Number.isInteger(n) && n > 0) parsed.push(n);
      }
      continue;
    }

    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) continue;

      if (trimmed.startsWith("[")) {
        try {
          parsed.push(...normalizeProductIds(JSON.parse(trimmed)));
          continue;
        } catch {
          // fall through to numeric / comma parsing
        }
      }

      if (trimmed.includes(",")) {
        parsed.push(...normalizeProductIds(trimmed.split(",")));
        continue;
      }

      const n = Number(trimmed);
      if (Number.isInteger(n) && n > 0) parsed.push(n);
      continue;
    }

    const n = Number(value);
    if (Number.isInteger(n) && n > 0) parsed.push(n);
  }

  return [...new Set(parsed)];
}

export async function getProducts(ids = []) {
  const uniqueIds = normalizeProductIds(ids);
  if (uniqueIds.length === 0) return [];

  const params = new URLSearchParams({ ids: uniqueIds.join(",") });

  const res = await apiFetch(`products/get?${params}`, { method: "GET" });

  let body = [];
  try { body = await res.json(); } catch {}

  if (!res.ok) {
    const msg = body?.detail || `Failed to retrieve products`;
    throw new Error(msg);
  }

  return body; // array of products
}